import { Modal, Input, Form, Button, Select, InputNumber } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, LoadingOutlined, PlusCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

function CustomModal({
  title,
  open,
  fields,
  onCancel,
  onSubmit,
  form,
  loading = false,
  onFormValuesChange,
  icon,
  confirmButtonText = "Add",
  closable = true,
}) {
  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={""}
      open={open}
      footer={null}
      closeIcon={null}
      width={400}
      centered
      onCancel={() => (closable ? handleCancel() : null)}
      afterClose={handleCancel}
    >
      <div className="flex gap-3 items-start">
        <div>
          {icon ? (
            icon
          ) : (
            <PlusCircleOutlined className="!text-primary-main text-xl mt-0.5" />
          )}
        </div>
        <div className="flex flex-col flex-1">
          <span className="text-base font-semibold text-[rgba(0,0,0,0.88)]">
            {title}
          </span>
          <Form
            form={form}
            layout="vertical"
            className="!mt-1"
            requiredMark={false}
            onValuesChange={(changedFields, allFields) =>
              onFormValuesChange?.(changedFields, allFields, form)
            }
          >
            {fields.map((field) => (
              <Form.Item
                key={field.name}
                name={field.name}
                label={
                  field.label ? (
                    <div>
                      <span className="!text-xs font-medium !text-[#344054]">
                        {field.label}
                      </span>
                      {field.required && (
                        <span className="!text-xs font-medium !text-red-500">
                          *
                        </span>
                      )}
                    </div>
                  ) : null
                }
                rules={[
                  {
                    required: field.required,
                    message: field.label
                      ? `Please enter ${field.label.toLowerCase()}`
                      : field.requiredMsg,
                  },
                ]}
                className={`!mb-0 ${!field.label ? "!mt-4" : ""}`}
              >
                {field.type === "input" ? (
                  <Input
                    placeholder={field.placeholder}
                    className="!rounded-[8px] !h-8 !text-xs"
                  />
                ) : field.type === "textarea" ? (
                  <TextArea
                    placeholder={field.placeholder}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    className="!rounded-[8px] !h-8 !text-xs"
                  />
                ) : field.type === "number" ? (
                  <InputNumber
                    placeholder={field.placeholder}
                    className="!rounded-[8px] !py-0.5 !text-xs !w-full !h-8"
                  />
                ) : field.type === "password" ? (
                  <Input.Password
                    placeholder={field.placeholder}
                    className="!rounded-[8px] !py-0.5 !text-xs !w-full !h-8"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                ) : (
                  <Select
                    placeholder={field.placeholder}
                    className="!rounded-[8px] !h-8 !text-xs"
                    options={field.options?.map((option) => ({
                      label: <span className="!text-xs">{option.label}</span>,
                      value: option.value,
                    }))}
                    filterOption={
                      field.filterOption === true
                        ? (input, option) => {
                            return String(option?.label.props.children)
                              .toLowerCase()
                              .includes(String(input).toLowerCase());
                          }
                        : field.filterOption
                        ? field.filterOption
                        : false
                    }
                    onSearch={field.onSearch}
                    showSearch
                    loading={field.loading}
                  />
                )}
              </Form.Item>
            ))}

            <div className="flex gap-2 justify-end pt-4">
              <Button
                onClick={handleCancel}
                disabled={loading}
                className="!h-8 !rounded-md !border !border-[#D0D5DD] !shadow-[0px_1px_2px_rgba(16,24,40,0.05)]"
              >
                <span className="text-sm font-medium text-[rgba(0,0,0,0.88)]">
                  Close
                </span>
              </Button>
              <Button
                loading={loading}
                type="primary"
                onClick={handleSubmit}
                className="!h-8 !rounded-md !bg-primary-tint !border-primary-tint !shadow-[0px_1px_2px_rgba(16,24,40,0.05)]"
              >
                {loading ? <LoadingOutlined className="!text-white" /> : null}
                <span className="text-sm font-medium text-white">
                  {confirmButtonText}
                </span>
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default CustomModal;
